import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@fluentui/react';
import { SearchInput } from './search-input';
import { SEARCH_INPUT_TYPES } from './constants';

export const SearchInputStack = ({
  url,
  keywords,
  inputStatus,
  onUrlChange,
  onKeywordsChange,
  onSearch,
}) => (
  <div>
    <Stack tokens={{ childrenGap: 16 }} horizontal className="search-input-stack" >
      <SearchInput
        onSearch={onSearch}
        onChange={onUrlChange}
        type={SEARCH_INPUT_TYPES.WEBSITE}
        value={url}
        enabled={inputStatus.url}
      />
      <SearchInput
        onSearch={onSearch}
        onChange={onKeywordsChange}
        type={SEARCH_INPUT_TYPES.KEYWORD}
        value={keywords}
        enabled={inputStatus.keywords}
      />
    </Stack>
  </div>
);

SearchInputStack.propTypes = {
  onSearch: PropTypes.func.isRequired,
  onKeywordsChange: PropTypes.func.isRequired,
  onUrlChange: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  keywords: PropTypes.string.isRequired,
  inputStatus: PropTypes.shape({
    url: PropTypes.bool,
    keywords: PropTypes.bool,
  }).isRequired,
};
